import { keys } from './keys';

export function pickBy<T>(
  obj: StrictRecord<number, T>,
  predicate: (value: T, key: number) => unknown,
) {
  const result: StrictRecord<number, T> = {};
  keys(obj).forEach((key) => {
    // @ts-ignore -- fix me
    if (predicate(obj[key], key)) {
      result[key] = obj[key];
    }
  });
  return result;
}
